function PopupController(){
	this.className			= "PopupController";
	this.glob				= "/**";
	this.priority			= 999;
	this.globUseHash		= true;
};
PopupController.inheritsFrom( StandardController );
PopupController.prototype.swap = function(){
	this.setup();
};
PopupController.prototype.setup = function(){


	this.$body 				= $("body");
	this.$page 				= this.$body.find('.js-page');
	this.$popup 			= this.$body.find('.js-popup');
	this.$contactPopup 		= this.$body.find('.js-contact-popup');
	this.$popupButton		= this.$body.find('.js-popup-button');


	// Toggle contact popup
	this.$popupButton.off().on('click touchstart', (e) => {
		if(e.cancelable) e.preventDefault(); //touchstart can't call preventDefault

		const $target = $(e.currentTarget);

		// Contact popup
		if($target.attr('data-popup') === "contact"){
			const contactPopup = ContactForm.build(nav.part(0), $target.attr('data-service')); // Contact popup
		}

	}).on('touchend', (e) => {
		e.preventDefault(); //Call prevent default to stop the click
	});
	//this.$popupButton.trigger("click")

};